import React, { Component } from 'react';

class Home extends React.Component {
	render() {
		return (
			<div>
			<h1></h1>
			<p> 
			I am a Full-stack developer and Machine Learning / Deep Learning enthusiast who is currently pursuing Masters in Computer Science from New York University - Courant Institute of Mathematical Sciences.  
			I enjoy building architecture for webapps and building learning models. 
			I have 2.5 years of experience at General Electric - Healthcare, India and was accountable for the success of multiple collaborative projects with corporate hospitals and government of India. 
			I am a member of the honorable society of GE's global program: Edison Engineering Development Program.
			I enjoy sports especially Swimming and have represented my state in National Swimming meets, India and have won 2 silvers and 1 bronze medal.
			I am a travel enthusiast and have travelled 20 countries, looking forward to increase this count! 
			</p>
			</div>
			);
		}
	} 

	export default Home;


// WEBPACK FOOTER //
// ./src/writeups/home.js